import React from 'react';
import Autocomplete from 'react-autocomplete';
import CustomCheckbox from './CustomCheckbox';

const Filters = props => (
  <div className='row filter-row'>
    <div className='col-sm-3'>
      <div className='form-group'>
        <div className='dropdown dropdown-multi customToggle' id='compania'>
          <div className='dropdown-control'>
            <input className='dropdown-control-input' placeholder='Compañía' />
            <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
          <div className='dropdown-tooltip dropdown-menu'>
            <div className='dropdown-scroll'>
              <ul>
                {props.companias.map(compania =>
                  <li key={compania.id}>
                    <CustomCheckbox id={compania.id} label={compania.nombre} name='companyFilter' onChange={props.onCheck} isChecked={props.companyFilter} />
                  </li>
                )}
              </ul>
            </div>
            <div className='dropdown-acions'>
              <button className='btn btn-dark' type='button' onClick={props.searchByFilter}>
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='col-sm-3'>
      <div className='form-group'>
        <div className='dropdown dropdown-multi customToggle' id='areaVenta'>
          <div className='dropdown-control'>
            <input className='dropdown-control-input' placeholder='Aº de venta' />
            <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
          <div className='dropdown-tooltip dropdown-menu'>
            <div className='dropdown-scroll'>
              <ul>
                {props.areasVenta.map(area => (
                  <li key={area.id} >
                    <CustomCheckbox id={area.id} label={area.nombre} name='areaVentaFilter' onChange={props.onCheck} isChecked={props.areaVentaFilter} />
                  </li>
                ))}
              </ul>
            </div>
            <div className='dropdown-acions'>
              <button className='btn btn-dark' type='button' onClick={props.searchByFilter}>
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='col-sm-3 autocomplete'>
      <Autocomplete
        inputProps={{
          className: 'form-control',
          placeholder: 'Asesor Comercial',
        }}
        wrapperStyle={{
          display: 'inline-block',
          position: 'relative',
          zIndex: '10',
        }}
        getItemValue={item => item.vendedor}
        items={props.vendedores}
        menuStyle={{
          position: 'absolute',
          left: '0',
          top: '100%',
          maxHeight: '350px',
          overflow: 'auto',
          border: '1px solid #cccccc',
        }}
        renderItem={(item, isHighlighted) =>
          <div key={item.vendedor} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
            {item.descripcion}
          </div>
        }
        onChange={props.onChangeVendedores}
        value={props.vendedorName}
        onSelect={props.onSelectVendedores}
        // open={this.props.vendedores.length > 0}
      />
      <button className='btn btn-dark fSearch-go' type='button' onClick={props.searchByVendedor}>
        <i className='ion-android-arrow-forward' />
      </button>
    </div>
  </div>
);

export default Filters;



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/Filters.js